import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Services } from './../services-url';


@Injectable({
  providedIn: 'root'
})
export class BannerService {


  constructor(
    private http: HttpClient,
  ) { }

  getBanners(): Observable<any> {
    return this.http.get(Services.imagesBanner);
  }
}
